





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getNewsDetail } from '@/api/index';

@Component
export default class NewsDetail extends Vue {
  // 接收参数
  @Prop() public newsId!: number;
  public newsDetail: object = {};
  get time() {
    // 发布时间转换 年月日
    if ((this.newsDetail as any).publishTime) {
      return (this.newsDetail as any).publishTime.substr(0, 11);
    }
    return '';
  }
  get readNum() {
    if ((this.newsDetail as any).countTrace) {
      return `${(this.newsDetail as any).countTrace}已读`;
    }
    return '';
  }
  // 监听 新闻id
  @Watch('newsId')
  onNewsIdChange(val: number) {
    if (val !== 0) {
      getNewsDetail({ id: val }).then((res: any) => {
        if (res.code === 200) {
          this.newsDetail = res.data;
        }
      });
    }
  }
  // 跳转到首页
  public jumpToHome() {
    this.$emit('jumpToHome');
  }
  // 跳转到新闻动态列表
  public jumpToList() {
    this.$emit('jumpToList');
  }
}
